import { generateColumnGroup } from './utils';

const TableEmptyOrderbook = () => {
  const cellClass = 'orderbook-text-summary';
  return (
    <table className="empty-table">
      {generateColumnGroup()}
      <tbody>
        {Array.from({ length: 10 }).map((_, index) => (
          <tr key={`empty-row-${index.toString()}`}>
            {Array.from({ length: 6 }).map((_, index) => (
              <td key={`empty-${index.toString()}`} className={cellClass}>
                -
              </td>
            ))}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr key="empty-summary">
          <td key="bid-frequency-total" className={cellClass}>
            -
          </td>
          <td key="bid-total" className={cellClass}>
            -
          </td>
          <td key="total" className={`${cellClass} center`} colSpan={2}>
            TOTAL
          </td>
          <td key="offer-total" className={cellClass}>
            -
          </td>
          <td key="offer-frequency-total" className={cellClass}>
            -
          </td>
        </tr>
      </tfoot>
    </table>
  );
};

export default TableEmptyOrderbook;
